// extracted by mini-css-extract-plugin
var _1 = "styles-module__dataHeadings___G77cA";
var _2 = "styles-module__splitsBar___kLCcz";
var _3 = "styles-module__splitsData___UNr1J";
var _4 = "styles-module__splitsPace___x6rhx";
export { _1 as "dataHeadings", _2 as "splitsBar", _3 as "splitsData", _4 as "splitsPace" }
